export default {
    install: (app, options) => {
        app.config.globalProperties.$retrieveVisitedSuppliers = $retrieveVisitedSuppliers;
        app.config.globalProperties.$addVisitedSupplier = $addVisitedSupplier;
        app.config.globalProperties.$deleteVisitedSupplierByRefId = $deleteVisitedSupplierByRefId;
        app.config.globalProperties.$defineCart = $defineCart;
        app.config.globalProperties.$newCart = $newCart;
        app.config.globalProperties.$retrieveCart = $retrieveCart;
        app.config.globalProperties.$validateCartAndSupplier = $validateCartAndSupplier;
        app.config.globalProperties.$deleteCart = $deleteCart;
        app.config.globalProperties.$retrieveSupplierRefId = $retrieveSupplierRefId;
        app.config.globalProperties.$deleteSupplierRefId = $deleteSupplierRefId;
        app.config.globalProperties.$currency = $currency;
        app.config.globalProperties.$clearCurrency = $clearCurrency;
        app.config.globalProperties.$clearAllData = $clearAllData;
        app.config.globalProperties.$retriveCurrentPriceOfProd = $retriveCurrentPriceOfProd;
        app.config.globalProperties.$createAffiliateCodePhrase = $createAffiliateCodePhrase;
        app.config.globalProperties.$retrieveAffiliateCodePhrase = $retrieveAffiliateCodePhrase;
        app.config.globalProperties.$clearAffiliateCodePhrase = $clearAffiliateCodePhrase;
        app.provide('ShoppingCart', options);
    }
}


export function $retriveCurrentPriceOfProd(prod){

    let price = prod.promotionFlag?prod.unitPricePromo:prod.unitPriceBase;

    if(price){
        return price.replaceAll(',', '');
    }else{
        return prod.unitPriceBase.replaceAll(',', '');
    }

}
export function $currency(){

    var currency = this.$store.state.currency;
    if(currency){
        return currency;
    }else{
        if (typeof Storage !== "undefined") {            
            if(sessionStorage.getItem("currency")){
                let currencyInStorage=JSON.parse(sessionStorage.getItem("currency"));
                //console.log("Found currency in storage!");
                this.$store.dispatch('createCurrency',currencyInStorage); 
                return currencyInStorage;
            }
        }else{
            alert("Your browser doesn't support functinalities required for this application.");            
        }
    }
    return currency;
}

export function $retrieveCart(){
    let cart = this.$store.state.cart;
    if(cart){
        //console.log("Found cart in app storage.");
        return cart;
    }else{
        if (typeof Storage !== "undefined") {            
            if(sessionStorage.getItem("cart")){
                let cartInStorage = JSON.parse(sessionStorage.getItem("cart"));
                //console.log("Found cart in local storage.");                
                this.$store.dispatch('createCart',cartInStorage); 
                return cartInStorage;
            }
        }else{
            alert("Your browser doesn't support functinalities required for this application.");            
        }
    }
    //console.log("No Cart found.");
    return null;
}


export function $retrieveVisitedSuppliers(){
    if (typeof Storage !== "undefined") {            
        let temp=localStorage.getItem("suppliers");
        if(temp){
            let suppliers = JSON.parse(temp);
            if(Array.isArray(suppliers)){
                return suppliers;
            }
        }
        
    }
    return [];
}

export function $addVisitedSupplier(supplier){
    if (typeof Storage !== "undefined") {     
        var suppliers=this.$retrieveVisitedSuppliers();
        if(Array.isArray(suppliers)){
            var limit=0;
            var newSuppliers=suppliers.filter(e => {
                if(e.refId!==supplier.refId&&limit<9){
                    limit = limit+1;
                    return true;
                }else{
                    return false;
                }
            });
            if(!newSuppliers){
                newSuppliers=[];
            }
            newSuppliers.unshift(supplier);
            localStorage.setItem('suppliers',JSON.stringify(newSuppliers));
            
        }
    }
}

export function $deleteVisitedSupplierByRefId(supplierRefId){
    if (typeof Storage !== "undefined") {     
        var suppliers=this.$retrieveVisitedSuppliers();
        if(Array.isArray(suppliers)){
            
            /**
            var newSuppliers=suppliers.filter(e => {
                if(e.refId!==supplierRefId){
                    return true;
                }else{
                    return false;
                }
            });
            */

            var newSuppliers=suppliers.filter(e => 

                e.refId!==supplierRefId
                         
            );
            if(newSuppliers&&newSuppliers.length>0){
                localStorage.setItem('suppliers',JSON.stringify(newSuppliers));
            }            
            
            
        }
    }
}


export function $validateCartAndSupplier(){
    let cart=this.$retrieveCart();
    let supplierRefId=this.$retrieveSupplierRefId();

    if(supplierRefId){
        if(!cart||!cart.lineItems){
            this.$defineCart(this.$newCart(supplierRefId));
        }else{

            
            cart.supplierRefId=supplierRefId;            
            var verifiedItems=cart.lineItems.filter( e => ( e.item && supplierRefId===e.item.supplierRefId ));
            if(verifiedItems&&verifiedItems.length>0){
                cart.lineItems=verifiedItems;


                var totalItems = 0;
                var totalValue = 0.0;
                cart.lineItems.map((e) => {                    
                    totalItems = totalItems + e.count;
                    totalValue = parseFloat(totalValue) + parseFloat(e.itemValue);
                });
                cart.totalItems = totalItems;
                cart.totalValue = parseFloat(totalValue.toFixed(2));

            }else{
                this.$defineCart(this.$newCart(supplierRefId));
            }


        }
    }

    /** 

    if(supplierRefId){
        if(cart&&cart.lineItems&&cart.lineItems.length>0){
            for(var i=0;i<cart.lineItems.length;i++){
                if(!cart.lineItems[i].item){                   
                    //console.log("Cannot find line item.");
                    this.$router.push({ path: '/error' });
                }
                if(supplierRefId!==cart.lineItems[i].item.supplierRefId){  
                    //console.log("LineItem supplierRefId mismatched.");
                    this.$router.push({ path: '/error' });
                }
            }
        }
    }

    if(cart&&supplierRefId){
        if(supplierRefId!==cart.supplierRefId){
            //console.log("Cart SupplierRefId mismatched.");
            this.$newCart(supplierRefId);
            this.$router.push({ path: '/error' });
        }
    }
    */
}

export function $newCart(supplierRefId){    
    return { supplierRefId:supplierRefId, lineItems: [], totalItems: 0, totalValue: 0.0 };
}

export function $deleteCart(){
    this.$store.dispatch('removeCart'); 
    sessionStorage.removeItem('cart');    
}

export function $defineCart(cart) {
    if (cart) {
        //console.log('Cart Instc:', JSON.stringify(cart));
        this.$store.dispatch('createCart', cart);
        if (typeof Storage !== 'undefined') {
            sessionStorage.setItem('cart', JSON.stringify(cart));
        }        
    }
}

export function $retrieveSupplierRefId(){
    var subjectId=this.$store.state.subjectId;
    if(subjectId){
      //console.log("Found supplierRefId in store!");          
    }else{
        if (typeof Storage !== "undefined") {
          subjectId=sessionStorage.getItem("subjectId");
          if(subjectId){
            //console.log("Found supplierRefId in session!");
          }
        }
    }    
    return subjectId;
 }

export function $deleteSupplierRefId(){
    this.$store.dispatch('removeSubjectId');
    sessionStorage.removeItem('subjectId');    
} 

export function $clearCurrency(){
    this.$store.dispatch('removeCurrency');
    sessionStorage.removeItem('currency');    
}

export function $clearAllData(){
    this.$clearCurrency();
    this.$deleteSupplierRefId();
    this.$deleteCart();
}

export function $createAffiliateCodePhrase(afflCodePhrase){
    if (typeof Storage !== 'undefined') {
        if(afflCodePhrase){
            localStorage.setItem('affl',afflCodePhrase);
        }   
    }
}

export function $retrieveAffiliateCodePhrase(){
    if (typeof Storage !== 'undefined') {
        let afflCodePhrase=localStorage.getItem('affl');
        if(afflCodePhrase){
            return afflCodePhrase;
        }
    }
    return null;
}

export function $clearAffiliateCodePhrase(){
    if (typeof Storage !== 'undefined') {
        localStorage.removeItem('affl');
    }
}

